/**
 * What the manifest claims a lot is — the ground truth its answers are graded
 * against — in the words the manifest itself uses.
 *
 * The scorer keys a brand on a lowercase token ("trafficmaster", "ge"). Shown
 * as ground truth that reads like a typo, so the brand is printed the way the
 * manifest spells it, found among the words of its own product name.
 */
const alnum = (value) => String(value || '').toLowerCase().replace(/[^a-z0-9]/g, '');

// The end of the leading run of `word` that spells `count` letters and digits.
const prefixEnd = (word, count) => {
  let seen = 0;
  for (let index = 0; index < word.length; index += 1) {
    if (/[A-Za-z0-9]/.test(word[index])) seen += 1;
    if (seen === count) return index + 1;
  }
  return word.length;
};

export const displayManifestBrand = (expectedName, expectedBrand) => {
  const brand = alnum(expectedBrand);
  if (!brand) return '';
  const words = String(expectedName || '')
    .split(/\s+/)
    .map((word) => word.replace(/^[^A-Za-z0-9]+|[^A-Za-z0-9]+$/g, ''))
    .filter(Boolean);
  // A word names the brand when it is the brand, or the brand run into a
  // hyphen, an apostrophe or a number — never a longer word ("General" is not
  // GE). The first such word wins: a later "Deluxe Arcade Game" must not stand
  // in for the "Arcade-1UP" the line opens with.
  const namesBrand = (word) => {
    const key = alnum(word);
    if (key === brand) return true;
    return key.startsWith(brand) && /^[-'’0-9]/.test(word.slice(prefixEnd(word, brand.length)));
  };
  const word = words.find(namesBrand);
  if (!word) return String(expectedBrand);
  // "Dyna-Glo", "Arcade-1UP", "Member's" are the brand whole; "GE2.0" is GE and a size.
  const end = prefixEnd(word, brand.length);
  return /^[-'’]/.test(word.slice(end)) ? word : word.slice(0, end);
};
